<template>
    <div class="all">
        <div class="echart-grid">
            <div class="row clearfix">
                <!-- 数据汇总 -->
                <div class="grid-father wh65">
                    <div class="grid h533">
                        <div class="grid-header clearfix">
                            <h2 class="title">近7天热点事件趋势</h2>
                        </div>
                        <div class="grid-body mt15">
                            <div class="echart-warp h450">
                                <div class="no-data pt30" v-if="nodata.hotEventData"><img :src="$parent.baseUrl+'/static/images/no_data.png'" class="img"/><span class="text">没有数据哦...</span></div>
                                <lineChart id="hotEvent" :dataArray="hotEventData" v-if="hotEventData != ''" :colorArr="colorArr" :isShowLegend='false' :isShowArea="false" gridBot ="10"></lineChart>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 热点事件 -->
                <div class="grid-father wh35">
                    <div class="grid h533">
                        <div class="grid-header clearfix">
                            <h2 class="title">近7天热点事件总榜</h2>
                        </div>
                        <div class="grid-body mt15">
                            <ul class="news">
                                <li v-for="(item,index) in hotAllRank" :key="index">
                                    <router-link class="cr3d" :to="{path:''+$parent.baseUrl+'/eventDetail',query:{id:item.id}}" target="_blank">
                                        <span class="title ovhidden fl" :title="item.name"><i class="order">{{index+1}}</i>{{item.name}}</span>
                                        <i class="icons fr mt15" :class="[{'icon-up':item.up>0},{'icon-down':item.up<0},{'icon-middle':item.up==0}]"></i>
                                        <strong class="data-num fr">{{item.count}}</strong>
                                    </router-link>
                                </li>
                            </ul>
                            <div class="no-data pt30" v-if="nodata.hotAllRank"><img :src="$parent.baseUrl+'/static/images/no_data.png'" class="img"/><span class="text">没有数据哦...</span></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="warp mt20 clearfix">
            <!-- 中间分割线ken-line -->
            <span class="ken-line"></span>
            <div class="ku w363 fr">
                <div class="grid h-auto">
                    <div class="grid-header clearfix">
                        <h2 class="title">热门专题</h2>
                    </div>
                    <div class="grid-body mt15">
                        <ul class="event">
                            <li v-for="(item,index) in hotTopicsList" :key="index">
                                <router-link class="img" :to="{path:''+$parent.baseUrl+'/specialDetail',query:{id:item.id,name:item.name}}">
                                    <img class="img db" :src="[item.icon]" :onerror="defaultImg"/>
                                    <span class="name ac db">{{item.name}}</span>
                                </router-link>
                            </li>
                        </ul>
                        <div class="no-data pt30" v-if="nodata.hotTopicsList"><img :src="$parent.baseUrl+'/static/images/no_data.png'" class="img"/><span class="text">没有数据哦...</span></div>
                    </div>
                </div>
            </div>
            <div class="hidden minH440">
                <div class="warp-body">
                    <div class="firle clearfix">
                       <span class="tion">
                           <span class="drop-down mores">
                                <button class="btn btn-lightblue"><span class="text">全部</span><i class="icons"></i></button>
                                <ul class="option">
                                    <li @click="choseType(0)">全部</li>
                                    <li v-for="(item,index) in hotTypeList" :key="index" @click="choseType(index)">{{item}}</li>
                                </ul>
                            </span>
                        </span>
                        <span class="tion clearfix">
                            <span class="name">发布地区</span>
                            <city @cityCallback="citySelect"></city>
                        </span>
                        <span class="tion">
                            <div class="search-warp clearfix">
                                <button class="search-btn fr" @click="searchResult"><i class="icons search-icon"></i></button> 
                                <div class="hidden"><input type="text" placeholder="搜事件" class="input-text" v-model.trim="searchMsg"></div>
                            </div>
                        </span>
                    </div>
                    <div class="no-data pt30" v-if="nodata.hotList"><img :src="$parent.baseUrl+'/static/images/no_data.png'" class="img"/><span class="text">没有数据哦...</span></div>
                    <ul class="article-list mt10">
                        <li class="imgText clearfix" v-for="(item,index) in hotList" :key="index">
                            <router-link class="img fl" :to="{path:''+$parent.baseUrl+'/eventDetail',query:{id:item.id}}" target="_blank"><img :src="[item.icon]" :onerror="defaultImg"/></router-link>
                            <div class="hidden">
                                <div class="clearfix">
                                    <h2 class="fl"><router-link class="cr3d" :to="{path:''+$parent.baseUrl+'/eventDetail',query:{id:item.id}}" target="_blank">{{item.name}}</router-link></h2>
                                    <span class="fr">舆情指数 <strong class="color-blue fs18">{{item.exponent}}</strong></span>
                                </div>
                                <p class="mt5 color-8a8a99 ovhidden3">{{item.schemeDescription}}</p>
                                <p class="ziduan mt10">
                                    <router-link :to="{path:''+$parent.baseUrl+'/eventsKu',query:{type:item.typeId}}"><i class="tag tag-blue">{{hotTypeList[item.typeId]}}</i></router-link>　<span>{{item.createTime | timeFilter}}</span>
                                </p>
                            </div>
                        </li>
                    </ul>
                    <div class="mt20 ac" v-if="isShowMore">
                        <a class="more color-8a8a99" href="javascript:void(0);" @click="showMore">点击加载更多</a>
                    </div>
                    <div class="mt20 ac" v-if="isShowEnd">
                        <a class="more color-8a8a99" href="javascript:void(0);">数据已经全部加载完成啦~</a>
                    </div>
                </div>
            </div>
        </div>
	</div>
</template>
<script>
import city from '../../components/city.vue';
import lineChart from '../../components/echart/lineChart.vue';
export default {
    components:{lineChart,city},
    data() {
        return {
		    hotEventData:[],
            hotAllRank:[],
            typeName:'全部',
            searchMsg:'',
            hotList:[],
            hotTypeList:[],
            hotTopicsList:[],
            pageCur:1,
            pageNum:5,
            dataCount:0,
            province:'',//省份
            colorArr:["#30d258","#e52e45","#f76a44","#ff8121","#2475fb","#1abbf0","#7b37c8","#6a4f77","#c28000","#7dbf2e","#18c391","#4b8abb","#539e79","#d216d2","#bb0000"],
            defaultImg:'this.src="'+this.$parent.baseUrl+'/static/images/default.png"',
            isShowMore:false,
            isShowEnd:false,
            nodata:{
                hotEventData:false,
                hotAllRank:false,
                hotTopicsList:false,
                hotList:false
            }
        }
    },
    filters:{
        // typeFilter:function(value,typeArr){
        //     return typeArr[value]
        // },
        timeFilter:function(val){
            return val.split(" ")[0];
        },
    },
    mounted() {
        let that = this;
		that.$nextTick(()=> {
            that.dataAjax();
            that.hotListAjax();
        })
    },
    created() {
		
    },
    methods: {
        dataAjax(){
            let that = this;
            that.$parent.loadModal(true,'数据加载中...');
            that.$api.get('hotnews/index/index-hot-news-line-chart',null,r=>{
                that.$parent.returnCode(r,function(){
                    if(r.data==''){
                        that.nodata.hotEventData = true;
                        return
                    }else{
                        that.nodata.hotEventData = false;
                    }
                    that.hotEventData = r.data;
                });
            });
            that.$api.get('hotnews/index/index-hot-news-rank',null,r=>{
                that.$parent.returnCode(r,function(){
                    if(r.data.list.length<=0){
                        that.nodata.hotAllRank = true;
                        return
                    }else{
                        that.nodata.hotAllRank = false;
                    }
                    that.hotAllRank = r.data.list;
                });
            });
            
            that.$api.get('hotnews/index/hot-topics',{perpage:4,isHot:1},r=>{
                that.$parent.returnCode(r,function(){
                    that.$parent.loadModal(false);
                    if(r.data.list.length<=0){
                        that.nodata.hotTopicsList = true;
                        return
                    }else{
                        that.nodata.hotTopicsList = false;
                    }
                     that.hotTopicsList = r.data.list;
                });
            });
            that.$api.get('hotnews/index/hot-news-type',null,r=>{
                that.$parent.returnCode(r,function(){
                     that.hotTypeList = r.data;
                });
            });
        },
        hotListAjax(){
            let that = this;
            that.$api.get('hotnews/index/hot-news-list',{type:that.typeName,query:that.searchMsg,perpage:that.pageNum,province:that.province,page:that.pageCur},r=>{
                that.$parent.returnCode(r,function(){
                    if(r.data.list.length<=0 && that.pageCur === 1){
                        that.nodata.hotList = true;
                        return
                    }else{
                        that.nodata.hotList = false;
                    }
                    that.dataCount = r.data.count;
                    if(that.dataCount>that.pageNum*that.pageCur){
                        that.isShowMore = true;
                    }else{
                        that.isShowMore = false;
                        that.isShowEnd = true;
                    }
                    that.hotList = that.hotList.concat(r.data.list);
                });
                
            });
        },
        // 地区筛选
        citySelect (name) {
            let province = name[1];
            let that = this;
            if(province === '全国'){
                that.province = '';
            }else{
                that.province = province;
            }
            that.clearListData();
        },
        //监听下拉组件传递信息
        clearListData(){
            let that = this;
            that.isShowMore = false;
            that.isShowEnd = false;
            that.pageCur = 1;
            that.hotList = [];
            that.hotListAjax()
        },
        choseType(type){
            let that = this;
            that.typeName = type;
            that.clearListData()
        },
        searchResult(){
           this.clearListData()
        },
        // 分页
        showMore(){
            let that = this;
            that.pageCur++;
            if(that.dataCount>((that.pageCur-1)*that.pageNum)){
                that.hotListAjax();
            }
        }
	}
}
</script>



// WEBPACK FOOTER //
// src/page/hotSpotEvents/eventsIndex.vue